import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=5b5ce52d&scoped=true&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=5b5ce52d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ce52d",
  null
  
)

export default component.exports